import XLSX from 'xlsx';
import i18n from '@/i18n';
import moment from 'moment-timezone';

export default class ExcelGen {
    static exportToXlsx(report) {
        switch (report.type) {
            case 'total_sales_report':
                this.exportSalesToXlsx(report);
                break;
            case 'stock_report':
                this.exportStockDataToXlsx(report);
                break;
            default:
                console.error('Unsupported report type:', report.type);
        }
    }

    static exportSalesToXlsx(report) {
        if (!report.data || !Array.isArray(report.data.sales)) {
            console.error('Invalid report data for sales. Expected format: { data: { sales: [...] } }');
            return;
        }

        let table = [];

        report.data.sales.forEach((saleItem) => {
            table = table.concat(this.generateColumnsAndData(saleItem, report.type));

            const footerData = {
                price: saleItem.price,
                discount_amount: saleItem.discount_amount,
                to_pay: saleItem.to_pay,
            };
            table = table.concat(this.generateFooter(footerData, Object.keys(saleItem).length));

            // Adding blank row between sales categories
            if (report.data.sales.length > 1) table.push([]);
        });

        this.createXlsxFile(table, report.type);
    }

    static generateColumnsAndData(sales, reportType) {
        let table = [];
        let columns = [];

        for (const sale of sales.items) {
            if (columns.length === 0) {
                for (const prop in sale) columns.push(prop);

                // Adding price column last in array
                if (columns.find((col) => col === 'price')) {
                    columns = columns.filter((col) => col !== 'price');
                    columns.push('price');
                }
            }

            let rows = [];
            columns.forEach((item) => rows.push(sale[item]));
            table.push(rows);
        }

        const columnsLocalised = {
            name: reportType === 'sales_by_product_category' ? sales.group : i18n.t('general.' + sales.group),
            code: i18n.t('general.code'),
            count: i18n.t('general.quantity'),
            price: i18n.t('general.sales'),
            in_stock: i18n.t('general.in_stock'),
            discount_amount: i18n.t('general.discount'),
        };

        // Translating columns according to localisation
        columns = columns.map((col) => (columnsLocalised[col] ? columnsLocalised[col] : ''));

        table.unshift(columns);

        return table;
    }

    static generateFooter(footer, reportSalesLength) {
        let table = [];

        if (footer.price && footer.discount_amount && footer.to_pay) {
            let footerArr = [];

            const propNamesLocalised = {
                price: i18n.t('general.price'),
                discount_amount: i18n.t('general.discount'),
                to_pay: i18n.t('general.to_pay'),
            };

            // Adding empty row in table
            table.push([]);

            for (const footerProp in footer) {
                footerArr = [];

                for (let i = 0; i < reportSalesLength; i++) {
                    if (i == 0) footerArr.push(propNamesLocalised[footerProp]);
                    else footerArr.push('');
                    if (i == reportSalesLength - 1 && footer[footerProp]) footerArr.push(footer[footerProp]);
                }

                table.push(footerArr);
            }
        }

        return table;
    }

    static exportStockDataToXlsx(report) {
        if (!report.data || !Array.isArray(report.data)) {
            console.error('Invalid report data for stock_data. Expected format: { data: [...] }');
            return;
        }

        let table = [];

        // Define the column headers
        const columns = [
            i18n.t('general.inventory_item'),
            i18n.t('general.current_stock'),
            i18n.t('general.inventory_count'),
            i18n.t('general.difference'),
        ];

        table.push(columns);

        // Add rows
        report.data.forEach((item, index) => {
            const row = [
                item.key,
                item.values[0],
                '',
                { f: `C${index + 2}-B${index + 2}` },
            ];
            table.push(row);
        });

        this.createXlsxFile(table, moment().format('DD-MM-YYYY-HH-mm-ss') + '_' + report.type);
    }

    static createXlsxFile(table, fileName) {
        const ws = XLSX.utils.aoa_to_sheet(table);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'data');
    
        const columnWidths = table[0].map((col, i) => ({
            wch: Math.max(...table.map(row => (row[i] ? row[i].toString().length : 10))) + 2
        }));
    
        ws['!cols'] = columnWidths;
    
        XLSX.writeFile(wb, fileName + '.xlsx');
    }
}
